import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { Amplify } from 'aws-amplify';
import { environment } from './app/environments/environment';
import { MonitoringService } from './app/core/services/monitoring.service';

// Initialize Sentry before anything else so that early errors are captured.
MonitoringService.init();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognitoPoolId,
      userPoolClientId: environment.cognitoPoolClientId,
    }
  }
});

// Register service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    const alreadyRegistered = regs.some(reg => reg.active?.scriptURL.includes('firebase-messaging-sw.js'));

    if (!alreadyRegistered) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    } else {
      console.log('Service worker already registered, skipping.');
    }
  });
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => {
    // Capture bootstrap errors in Sentry as well
    MonitoringService.captureException(err, { location: 'bootstrapModule' });
    console.error(err);
  });
